import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../ui/accordion";
import { FAQ } from "@/data/site";

export default function Faq() {
  return (
    <section id="faq" data-testid="faq-section" className="relative py-24 md:py-32 bg-ink-800">
      <div className="max-w-5xl mx-auto px-6 md:px-10 lg:px-12">
        <div className="text-center mb-14">
          <p className="text-xs tracking-[0.3em] uppercase text-gold mb-5">Häufige Fragen</p>
          <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl text-white tracking-tight leading-tight">
            FAQ —<br />
            <span className="italic text-gold-soft">kurz und klar.</span>
          </h2>
        </div>

        <Accordion type="single" collapsible className="space-y-3">
          {FAQ.map((item, idx) => (
            <AccordionItem
              key={idx}
              value={`item-${idx}`}
              data-testid={`faq-item-${idx}`}
              className="border border-ink-500/60 bg-ink-900 px-6 data-[state=open]:border-gold/40 transition-colors"
            >
              <AccordionTrigger className="text-left text-white hover:text-gold hover:no-underline py-5 font-display text-lg">
                {item.q}
              </AccordionTrigger>
              <AccordionContent className="text-zinc-400 leading-relaxed pb-5">
                {item.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
